<!-- Detailinfo.vue -->
<template>
	<div v-if="detailInfo">
		<!-- <div v-if="detailInfo.bargain_info" class="bargain-wrapper">

			<div class="bargain-content" @click="bargainVisible = true">
				<div class="title">砍价购</div>
				<div class="content">
					<div>距结束仅剩</div>
					<div><span v-if="day"><em>{{ day }}</em>天</span><span><em>{{ hours }}</em>时</span><span><em>{{ minute
					}}</em>分</span><span><em>{{ second }}</em>秒</span>
					</div>
				</div>
				<div class="arrow iconfont">&#xe650;</div>
			</div>
			<mt-popup v-model="bargainVisible" position="bottom" class="bargain-popup-wrapper">
				<div class="mt">玩法详情</div>
				<div class="mc">
					<div class="line">
						1.活动期间消费者可邀请好友帮忙砍价，好友砍到底价后，即可按底价购买商品；
					</div>
					<div class="line">
						2.好友帮忙砍到底价后，消费者须在有效期内购买砍价商品，逾期商品将恢复原价；
					</div>
					<div class="line">
						3.同一商品，同一用户仅可享受一次优惠价格；
					</div>
					<div class="line">
						4.同一商品，同一用户仅能帮好友砍价一次；
					</div>
					<div class="line">
						5.砍价商品数量有限，商品售罄后，您将无法购买。
					</div>
				</div>
			</mt-popup>
		</div> -->
		<div class="ui-detail-info">

			<div class="info-header ui-flex">
				<h3>{{ detailInfo.goods_name }}</h3>
				<!-- <div class="favorite">
					<i class="iconfont" v-on:click="productUnlike()" v-if="isFavorate">&#xe6d5;</i>
					<i class="iconfont" v-on:click="productLike()" v-else>&#xe6d6;</i>
					<span>{{ favoriteName }}</span>
				</div> -->
			</div>
			<div class="goods_advword" v-if="detailInfo.goods_advword"><span class="strong">{{ detailInfo.goods_advword
					}}</span></div>
			<div v-if="detailInfo.wholesale_info" class="price" style="display: flex">
				<div v-for="(item, index) in detailInfo.wholesale_info.wholesalegoods_price" :key="index"
					style="flex:1">
					<span class="current-price">$<i class="price-number">{{ item.price }}</i></span>
					<span class="num">{{ item.num_text }}</span>
				</div>
			</div>
			<div v-else class="price">
				<span class="current-price">$<i class="price-number">
						<slot v-if="detailInfo.bargain_info">{{ detailInfo.bargain_info.bargain_floorprice }}</slot>
						<slot v-else-if="detailInfo.pintuan_type">{{ detailInfo.pintuan_price }}</slot>
						<slot v-else-if="detailInfo.promotion_type">{{ detailInfo.promotion_price }}</slot>
						<slot v-else>{{ detailInfo.goods_price }}</slot>
					</i>
				</span>
				<span class="old-price" v-if="detailInfo.goods_marketprice > 0">${{ detailInfo.goods_marketprice
					}}</span>
			</div>
			<div class="inviter_amount" v-if="detailInfo.inviter_money > 0">
				<span class="inviter_amount">分销佣金：${{ detailInfo.inviter_money }}</span>
			</div>

			<div v-if="!detailInfo.bargain_info">
				<div class="info-promotions" v-if="detailInfo.pintuan_type == 'pintuan'">
					<div class="left">
						<i>拼团</i>
						<span v-if="detailInfo.pintuan_limit_quantity">最多可购买{{ detailInfo.pintuan_limit_quantity
							}}件</span>
					</div>
					<span class="right">{{ fromNow(detailInfo.pintuan_end_time) }}结束</span>
				</div>
				<div class="info-promotions" v-if="detailInfo.promotion_type == 'groupbuy'">
					<div class="left">
						<i>抢购</i>
						<span v-if="detailInfo.upper_limit">最多可购买{{ detailInfo.upper_limit }}件</span>
					</div>
					<span class="right">{{ fromNow(detailInfo.promotion_end_time) }}结束</span>
				</div>
				<div class="info-promotions" v-if="detailInfo.promotion_type == 'xianshi'">
					<div class="left">
						<i>秒杀</i>
						<span v-if="detailInfo.lower_limit">最低{{ detailInfo.lower_limit }}件起</span>
					</div>
					<span class="right">{{ fromNow(detailInfo.promotion_end_time) }}结束</span>
				</div>
				<div class="info-promotions" v-if="detailInfo.promotion_type == 'presell'">
					<div class="left">
						<i>预售</i>
						<span v-if="detailInfo.remark">{{ detailInfo.remark }}</span>
					</div>
					<span class="right">{{ fromNow(detailInfo.presell_end_time) }}结束</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { productLike, productUnlike } from '../../../../api/homegoodsdetail'
import { Toast, Indicator } from 'mint-ui'
export default {
	data() {
		return {
			bargainVisible: false,
			flag: false,
			day: 0,
			hours: 0,
			minute: 0,
			second: 0,
			time: false,
			orderTime: '', // 下单时间
			arrivalsTime: '', // 到达时间
			arrivalsTitle: '', // 到达时间的标题
			arrivalsRange: '' // 到达时间区间,
		}
	},
	computed: {
		...mapState({
			isFavorate: state => state.goodsdetail.isFavorate,
			detailInfo: state => state.goodsdetail.detailInfo,
			currentProductId: state => state.goodsdetail.currentProductId,
			user: state => state.member.info
		}),
		favoriteName() {
			return this.isFavorate ? this.$t('Unfollow') : this.$t('Follow')
		}
	},
	created() {
	},
	mounted() {
		this.time = setInterval(() => {
			if (this.flag == true) {
				clearInterval(this.time)
			} else {
				this.timeDown()
			}
		}, 1000)
	},
	methods: {
		...mapMutations({
			saveInfo: 'saveDetailInfo',
			changeIndex: 'changeIndex',
			saveIsFavorate: 'saveIsFavorate'
		}),
		fromNow(time) {
			return this.$moment(time * 1000).fromNow()
		},
		/*
		 * getCommentStatus： 去到评论页面
		 */
		getCommentStatus() {
			this.changeIndex(2)
		},
		/*
		 * productLike： 收藏商品
		 */
		productLike() {
			if (this.user) {
				let id = this.detailInfo.goods_id
				productLike(id).then(res => {
					if (res) {
						this.saveIsFavorate(true)
					}
				}).catch(function (error) {
					Toast(error.message)
				})
			} else {
				this.$router.push({ name: 'HomeMemberLogin' })
			}
		},
		/*
		 * productUnlike： 取消收藏
		 */
		productUnlike() {
			if (this.user) {
				let id = this.detailInfo.goods_id
				productUnlike(id).then(res => {
					if (res) {
						this.saveIsFavorate(false)
					}
				})
			} else {
				this.$router.push({ name: 'HomeMemberLogin' })
			}
		},

		/*
		 * timeDown: 倒计时
		 */
		timeDown() {
			let end_time = false
			if (this.detailInfo.bargain_info) {
				end_time = this.detailInfo.bargain_info.bargain_endtime
			}
			if (end_time) {
				const endTime = new Date(end_time * 1000)
				const nowTime = new Date()
				let leftTime = parseInt((endTime.getTime() - nowTime.getTime()) / 1000)
				this.day = parseInt(leftTime / (24 * 60 * 60))
				this.hours = this.formate(parseInt((leftTime / (60 * 60)) % 24))
				this.minute = this.formate(parseInt((leftTime / 60) % 60))
				this.second = this.formate(parseInt(leftTime % 60))
				if (leftTime <= 0) {
					this.flag = true
					this.detailInfo.bargain_info = ''
					this.saveInfo(this.detailInfo)
				}
			}
		},
		/*
		 * 格式化时间
		 */
		formate(time) {
			if (time >= 10) {
				return time
			} else {
				return `0${time}`
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.bargain-wrapper {
	.bargain-content {
		padding: .5rem;
		color: #fff;
		background: #EA3F64;
		background-image: linear-gradient(to right, #ff5e00, #ea3f3f);
		display: flex;

		.title {
			flex: 1;
			font-size: $h1;
			line-height: 1.2rem;
		}

		.content {
			width: auto;
			font-size: $fontSize;
			line-height: .6rem;

			em {
				margin: 0 .1rem
			}
		}

		.arrow {
			width: 1rem;
			text-align: right;
			line-height: 1.2rem;
		}

	}

	.bargain-popup-wrapper {
		padding: .5rem;
		color: #333;
		box-sizing: border-box;
		padding-bottom: 3rem;

		.mt {
			font-size: $h2;
			text-align: center
		}

		.mc {
			font-size: $fontSize;

			.line {
				margin-top: .5rem;
			}
		}
	}
}

.ui-detail-info {
	height: 100%;
	margin-left: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	-webkit-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: space-between;
	padding: 0 $pageSpace;

	.ui-flex {
		display: flex;
		/*justify-content: space-between;*/
		align-content: center;
		align-items: center;
		flex-basis: 100%;
		width: auto;
	}

	.info-header {
		padding-top: 1.4rem;

		h3 {
			width: 561px;
			font-size: 18px;
			color: #333;
			height: 108px;
			line-height: 36px;
			white-space: normal;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
		}

		.favorite {
			height: 2.4rem;
			text-align: center;

			i {
				width: 2.4rem;
				display: block;
				font-size: 1.2rem;
				line-height: 1.2rem;
				color: $primaryColor;
			}

			span {
				font-size: $h6;
				line-height: 1rem;
				height: 1rem;
				display: block;
			}
		}
	}

	.goods_advword {
		font-size: $fontSize;
		padding: .2rem .4rem;
		margin-bottom: .5rem;
		background: $subColor;
		color: $primaryColor
	}

	.price {
		padding-bottom: 0.4rem;
		display: flex;

		span {
			display: block;
			font-weight: normal;

			&.current-price {
				font-size: 36px;
				color: #ec3031;
				margin-right: 20px;

				.price-number {
					font-size: 36px;
					color: #ec3031;
					margin-right: 20px;
				}
			}

			&.num {
				font-size: $fontSize;
				color: #666;
			}

			&.old-price {
				font-size: 30px;
				color: #bfbfbf;
				-webkit-text-decoration-line: line-through;
				text-decoration-line: line-through;
			}
		}
	}

	.inviter_amount {
		padding-bottom: 0.4rem;
		display: flex;

		span {
			font-size: $subFontSize;
			color: #4e545d;
		}
	}

	.info-sub {
		border-bottom: 0.5px solid #e8eaed;
		padding-bottom: 0.25rem;

		p {
			padding: 0;
			margin: 0;
			color: $primaryColor;
			font-size: $h6;
		}
	}

	.info-promotions {
		display: flex;
		justify-content: flex-start;
		align-content: center;
		align-items: center;
		padding: 0.75rem 0;
		border-bottom: 1px dashed #eee;
		line-height: 1.5rem;

		span {
			margin-left: 0.75rem;
			font-size: $fontSize;
			color: rgba(143, 142, 148, 1);
		}

		img {
			width: 30.4rem;
		}
	}

	.info-promotions i {
		font-size: $subFontSize;
		border: 1px solid $primaryColor;
		color: $primaryColor;
		padding: 0.1rem 0.3rem;
		border-radius: 0.1rem;
	}

	.info-promotions .left {
		flex: 1
	}

	.info-promotions .right {
		width: 4rem;
		text-align: right
	}
}
</style>
